// extracted by mini-css-extract-plugin
module.exports = {"addressWrapper":"Address_addressWrapper__3cUjK","title":"Address_title__14qaN","addressTable":"Address_addressTable__2jjrc"};